module.exports = {
  API_MAIN: "API_MAIN",
  API_LUKE: "API_LUKE",
  API_DATASTORE: "API_DATASTORE",
  API_NODE_SERVER: "API_NODE_SERVER",
};
